import React, { useState } from "react";
import css from "./TrafficLights.module.css";

function TrafficLights({ isClicked, setIsClicked }) {
  //finance-light
  //management-light
  //legal-light

  const [fSigned, setFSigned] = useState(false);
  const [mSigned, setMSigned] = useState(false);
  const [lSigned, setLSigned] = useState(false);

  return (
    <>
      <div className={css.lightscontainer}>
        <div
          className={css.finance}
          style={{
            backgroundColor: fSigned ? "green" : "red",
            borderRadius: "100%",
            height: "30px",
            width: "30px"
          }}
          onClick={() => {
            setFSigned(true);
            setIsClicked(true);
          }}
        >
          <p className={css.letter}>F</p>
        </div>
        <div
          className={css.management}
          style={{
            backgroundColor: mSigned ? "green" : "red",
            borderRadius: "100%",
            height: "30px",
            width: "30px"
          }}
          onClick={() => setMSigned(true)}
        >
          <p className={css.letter}>M</p>
        </div>
        <div
          className={css.legal}
          style={{
            backgroundColor: lSigned ? "green" : "red",
            borderRadius: "100%",
            height: "30px",
            width: "30px"
          }}
          onClick={() => setLSigned(true)}
        >
          <p className={css.letter}>L</p>
        </div>
      </div>
      {fSigned ? null : (
        <>
          <label>Authorised By: </label>
          <input type="text" className={css.input} />
        </>
      )}
      {fSigned && mSigned && lSigned && (
        <div className={css.emailcontainer}>
          <p className={css.emailpara}>
            Email provider to confirm contract has been completed:
          </p>
          <button className={css.button}>Check Provider Details</button>
          <button className={css.button}>Send Email</button>
        </div>
      )}
    </>
  );
}

export default TrafficLights;
